import CtvDialogPopup from '@camtv/front-base-ui/lit/dialog-popup'
import axios from 'axios'

document.addEventListener('DOMContentLoaded', () => {

    // Imposta il submit dei form
    let vforms = document.querySelectorAll("form:not(#CONTACT_US)")
    vforms.forEach((form) => {
        try {

            let button = form.querySelector("button")
            form.onsubmit = (evt) => {
                evt.preventDefault()

                let endpoint = form.getAttribute("data-endpoint")
                let modal = form.getAttribute("data-modal")
                if (endpoint == null || endpoint == "")
                    return;

                button.setAttribute("disabled", "disabled")
                button.style.minWidth = button.getBoundingClientRect().width + "px"
                let ih = button.innerHTML
                button.innerHTML = `<i class="fa fa-spinner fa-spin"></i>`;

                let data = {}
                form.querySelectorAll("[data-param]").forEach((input) => {
                    let key = input.getAttribute("data-param")
                    data[key] = input.value
                })

                let options = {
                    headers: {}
                };
                // Nota: NON impostare Content-Type a mano. Con una FormData ci pensa
                // axios, che aggiunge il boundary. Senza boundary il server non riesce
                // a leggere il corpo della richiesta.
                if (form.querySelector('input[type="file"]')) {
                    data = new FormData(form)
                }



                axios.post(endpoint, data, options).then(async (ret) => {
                    CtvDialogPopup.ShowMessageBox("{%T|Grazie|%}", "{%T|La tua richiesta è stata inoltrata con successo. Ti contatteremo nel più breve tempo possibile.|%}")
                    // window.modal = new bootstrap.Modal(document.getElementById(modal))
                    // window.modal.show()
                    // reset completo solo se l'invio e' andato a buon fine:
                    // form.reset() svuota anche radio, checkbox e allegati, che il
                    // ciclo sui soli [data-param] non toccava.
                    form.reset()
                }).catch((err) => {
                    console.error("Invio form fallito:", err)
                    CtvDialogPopup.ShowMessageBox(
                        "{%T|Invio non riuscito|%}",
                        "{%T|Non siamo riusciti a inviare la richiesta. Riprova tra poco oppure scrivici a info@hasofir.com|%}")
                }).finally(() => {
                    button.removeAttribute("disabled")
                    button.innerHTML = ih
                })
            }

        }
        catch (Ex) {
            console.error(Ex)
        }
    })

})